<template>
	<component :is="component" :class="$style.root">
		<slot />
	</component>
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

/*
 * TODO: this doesn't really look like the DialogHeader / DialogContent
 */

export default {
  name: 'DialogFooter',

  mixins: [ defaultRootComponent('div') ]
}

</script>

<style module>

.root {	
	@apply
			p-4
			border-t
			border-solid
			border-dull;
}

</style>
